/**
 * The phone's words for the visit's Service Report (piece 35, *The fourth
 * release*; decisions 4641, 4660), kept beside the other releases' and spread
 * into the one string lookup. A word the web's report already says, such as
 * Start Line, Complete the Visit or Service Report: Send, is read from the
 * web's own key and is not repeated here.
 */
export const SERVICE_REPORT_PHONE_STRINGS = {
  'mobile.report.backToBoard': 'Back to My Jobs',
  'mobile.report.photos': 'Pictures',
  // Decision 5220: a note waiting for signal names how many pictures it carries.
  'mobile.report.waitingPictures': 'Pictures: {count}',
  'mobile.report.returnHint': 'The day and the times are read in your own time zone.',
  'mobile.report.returnDay': 'Day',
  'mobile.report.heldNote': 'Write a note or add a picture to go on.',
  'mobile.report.heldRecord': 'Choose the line and type the hours and a note to go on.',
  'mobile.report.heldMinutes': 'Type the minutes to go on.',
  'mobile.report.heldReturn': 'Type the day and the start time to go on.',
  'mobile.report.returnCrew': 'The same crew goes: {crew}. Change the crew on the web.',
  'mobile.report.returnTyped': 'Type the day as YYYY-MM-DD and the start as HH:MM.',
  'mobile.report.returnOrder': 'The visit ends after it starts.',
  'mobile.report.sheetDrawn': 'The sheet as it will print. The customer signs beneath it.',
  'mobile.report.padHint': 'Sign with a finger inside the box.',
  'mobile.report.sendNobody': 'Tick at least one contact with an email address.',
} as const;
